var ReactTooltip = require("react-tooltip");

require('support/help_center_link.scss')

class HelpCenterLink extends React.Component {

	constructor(props) {
		super()
		autobind(this);
		this.state = {
			showPopover: props.textOnly, activeEmotion: null,
			reactionFeedbackKey: null, feedbackItemID: null, loading: false
		}
	}

	render() {
		var url = "https://www.whooosreading.org/help"
		return (
			<div className="HelpCenterLink" onClick={(e) => {window.open(url, '_blank');}}>
				<div className="icon">
					<span className="glyphicon glyphicon-question-sign" aria-hidden="true"></span>
				</div>
				<div className="content">
					Open Help Center.
				</div>
			</div>
		)
	}
}

module.exports = HelpCenterLink;


// WEBPACK FOOTER //
// ./modules/components/support/help_center_link.js